import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import React from 'react';
import { ColumnContainer } from 'utils/columnsStyle';
import { useDispatch, useSelector } from 'react-redux';
import { useToggle } from "hooks/useToggle";
import { ModalV2 } from 'components/Modal/ModalV2';
import { Tooltip } from '@material-ui/core';
import {
  editComoDataTankMode,
  comoDataTankSelected,
  deleteComoDataTank
} from 'redux/actions/comoDataTanks/comoDataTanksActions';

const style = {
  color: '#004F9F',
  fontSize: 20,
  marginRight: 10,
  cursor: 'pointer'
}

export const columns = [
  {
    Header: "Marca",
    accessor: "brandName",
    filterable: true,
    filterMethod: (filter, row) => row.brandName.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Serie",
    accessor: "serie",
    filterable: true,
    filterMethod: (filter, row) => row.serie.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Activo Fijo",
    accessor: "fixedAssetNum",
    filterable: true,
    filterMethod: (filter, row) => row.fixedAssetNum?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Capacidad",
    accessor: "capacity",
    filterable: true,
  },
  {
    Header: "Descripción",
    accessor: "description",
    filterable: true,
    filterMethod: (filter, row) => row.description?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Estatus",
    accessor: "status",
    filterable: true,
    filterMethod: (filter, row) => row.status?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Acciones",
    filterable: false,
    sortable: false,
    Cell: ({ original }) => {
      const dispatch = useDispatch()
      const { rules } = useSelector(({ login }) => login)
      const [open, setOpen] = useToggle();
      const openEdit = () => {
        dispatch(editComoDataTankMode())
        original.modal(true)
        dispatch(comoDataTankSelected(original.id))
      }

      const handleDelete = () => {
        dispatch(deleteComoDataTank(original.id, setOpen))
      }

      const isAssigned = original.status === 'ASIGNADO'

      return (
        <ColumnContainer>
          <EditIcon style={style} onClick={openEdit} />
          {
            rules.includes('COMMODATOS-DELETE') && (
              isAssigned
                ? (
                  <Tooltip title="No se puede eliminar un tanque asignado">
                    <DeleteIcon style={{ ...style, color: '#e83737', opacity: 0.4, cursor: 'not-allowed' }} />
                  </Tooltip>
                )
                : <DeleteIcon style={{ ...style, color: '#e83737' }} onClick={setOpen} />
            )
          }
          <ModalV2
            title={'¿Estas seguro de eliminar tanque?'}
            onClose={setOpen}
            open={open}
            justConfirm
            onSubmit={handleDelete}
          />
        </ColumnContainer>
      )
    },
  },
];